import { Button, Card, Icon, Text } from "@shopify/polaris"
import { XIcon } from "polaris-enhance"

import APIAPP from "@/api/app"
import stores from "@/stores"

export function BookDemoBanner() {
  const { UserInfoStore } = stores

  return (
    <div className="w-full relative">
      <div className="absolute z-50 top-2 right-2 p-1">
        <Button
          variant="tertiary"
          icon={<Icon source={XIcon} />}
          onClick={async () => {
            UserInfoStore.setShowBanner("index_book_demo", 2)
            const res = await APIAPP.closeBanner(10)
            if (res.code !== 1000) {
              UserInfoStore.setShowBanner("index_book_demo", 1)
            }
          }}
        />
      </div>
      <Card padding="0">
        <div className="flex">
          <div className="w-[240px] h-[134px] flex-shrink-0 hidden sm:flex">
            <img
              src="https://return-cdn.parcelpanel.net/public/sales/book_demo.png"
              alt="bookdemo"
            />
          </div>
          <div className="p-4 space-y-4">
            <div className="flex flex-col gap-2">
              <div>
                <Text as="h2" variant="headingSm">
                  {t("BookAFree_1_1Demo")}
                </Text>
              </div>
              <Text as="p" variant="bodySm">
                {t("GetPersonalizedReturnSolutionsTailor")}
              </Text>
            </div>
            <div className="mt-3 flex gap-2">
              <Button
                variant={"primary"}
                onClick={() => {
                  APIAPP.report({ event: 1, opt: 1 })
                  window.open(
                    "https://calendly.com/channelwill-parcelpanel/meet-with-our-return-expert",
                    "_blank",
                  )
                }}
              >
                {t("GetAFreeDemo")}{" "}
              </Button>
              <Button
                onClick={() => {
                  // 获取GMT+8时区的当前时间
                  const now = new Date()
                  const gmt8Time = new Date(
                    now.getTime() +
                      8 * 60 * 60 * 1000 +
                      now.getTimezoneOffset() * 60 * 1000,
                  )
                  const hour = gmt8Time.getHours()

                  // 根据时间选择邮箱
                  // Harry: GMT8:00am-21:00pm (8:00-21:00)
                  // Michael: GMT21:01pm-7:59am (21:01-23:59 和 0:00-7:59)
                  const email =
                    hour >= 8 && hour <= 21
                      ? "harry@channelwill.io"
                      : "michael.b@channelwill.io"

                  window.open(`mailto:${email}?subject=Book%20a%20demo`)
                }}
              >
                {t("EmailUsNow")}
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}
